import { useLocalStorage } from 'react-use';

const tokenStorageKey = 'synqo.cloud.token';

export function useStoredToken() {
    const [token, setToken, removeToken] = useLocalStorage<string>(tokenStorageKey, '');

    return {
        token,
        setToken,
        removeToken,
    };
}
